import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import privateView from '../../components/hocs/privateView';
import Analytics from '../../services/Analytics';
import KickPointRedemptionForm from './KickPointRedemptionForm';

class KickPointRedemptionCreate extends Component {
  componentDidMount() {
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('kick_point_redemption_create', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  render() {
    return (
      <Container style={{ padding: 0 }}>
        <KickPointRedemptionForm title="Create Kick Point Redemption" {...this.props} />
      </Container>
    );
  }
}

const mapStateToProps = ({ auth: { isFetch, roles, isLogged, id, email } }) => ({
  guardData: { isFetch, roles, isLogged, id, email }
});

const enhance = connect(mapStateToProps);
export default enhance(privateView(KickPointRedemptionCreate, ['superadministrator', 'administrator']));
